import React from 'react';
import { Table, Form } from 'react-bootstrap';
import { useState, useEffect } from 'react';
import Select from 'react-select';
import { postRequestOptions, getRequestOptions } from "../helpers/Fetchwrapper";
import { Card } from 'react-bootstrap-v5';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { numberFormat } from '../helpers/GlobalHelper';
import { Link } from "react-router-dom";

interface Rows {
    idShipmentRows: Number;
    quantity: Number;
    productName: string;
    idProducts: Number;
    packing: string;
    size: string;
    unitName: string;
}

interface FreeRows {
    idShipmentFreeRows: Number;
    quantity: Number;
    productName: string;
    idProducts: Number;
    packing: string;
    size: string;
    unitName: string;
}

interface ActualExpectedStockData {
    idShipments: Number;
    idSalesOrders: Number;
    shipmentDate: string;
    chalanNo: string;
    invoiceId: string;
    companyName: string;
    salesPerson: string;
    remarks: string;
    orderAmount: any;
    rows: Rows[];
    free_rows: FreeRows[];
}

interface ActualExpectedStockReportProps {

}

const ActualExpectedStockReport: React.FC<ActualExpectedStockReportProps> = (props) => {

    const [loading, setLoading] = useState(false);
    const [expectedStockData, setExpectedStockData] = useState<ActualExpectedStockData[]>([]);
    const [formData, setFormData] = useState({
        idProjects: '',
        idItemCategories: '',
        fromDate: '',
        toDate: '',
    });

    const [projects, setProjects] = useState([]);
    const [project, setProject] = useState({ label: 'Select Project', value: '' });

    const [itemCategories, setItemCategories] = useState<{ label: string; value: string }[]>([]);
    const [itemCategory, setItemCategory] = useState<{ label: string; value: string }>({ label: 'Select Item Category', value: '' });

    useEffect(() => {
        getProjects();
        getItemCategories();
    }, [])

    useEffect(() => {
        if (projects.length > 0) {
            setProject(projects[0]);
            setFormData((prevFormData) => ({
                ...prevFormData,
                idProjects: projects[0].value,
            }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [projects]);
    
    const getProjects = () => {
        fetch(
            process.env.REACT_APP_API_URL + 'lead/projects',
            getRequestOptions()
        )
            .then((resp) => {
                return resp.json()
            })
            .then((resp) => {
                let projectObj = resp.data.map((item: any) => {
                    item.label = item.name;
                    item.value = item.id;
                    return item
                })
                setProjects(projectObj);
            })
            .catch((error) => {
                console.log(error, 'catch the hoop')
            })
    }

    const handleProjectChange = (project: any) => {
        setProject(project);
        if (project) {
            setFormData({ ...formData, idProjects: project.value });
        } else {
            setFormData({ ...formData, idProjects: '' });
        }
    }

    const getItemCategories = async () => {
        try {
            const response = await fetch(process.env.REACT_APP_API_URL + 'allItemCategories', getRequestOptions());
            const data = await response.json();
            
            if (data && Array.isArray(data)) {
                const categoryOptions = data.map((item: any) => ({
                    label: item.category_name,
                    value: item.id_item_categories
                }));
                
                const allOption = { label: 'All Item Categories', value: '' };
                setItemCategories([allOption, ...categoryOptions]);
            }
        } catch (error) {
            console.error('Error fetching item categories:', error);
        }
    }

    const handleItemCategoryChange = (selectedCategory: any) => {
        setItemCategory(selectedCategory);
        if(selectedCategory){
            setFormData({ ...formData, idItemCategories: selectedCategory.value });
        }else{
            setFormData({ ...formData, idItemCategories: '' });
        }
    }

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleViewReport = async () => {
        if (!formData.idProjects) {
            toast.error('Please select a project', { position: 'bottom-right', autoClose: 4000 });
            return;
        }
        if (!formData.fromDate || !formData.toDate) {
            toast.error('Please select both From Date and To Date', { position: 'bottom-right', autoClose: 4000 });
            return;
        }
        
        setLoading(true);

        try {
            const response = await fetch(process.env.REACT_APP_API_URL + 'reports/actual-expected-stock-status', postRequestOptions(formData));
            const data = await response.json();

            if (data.success) {
                setExpectedStockData(data.data);
            } else {
                setExpectedStockData([]);
                data.errors?.forEach((error: string) => toast.error(error, { position: 'bottom-right', autoClose: 4000 }));
            }
        } catch (error) {
            console.error('Error submitting data:', error);
            toast.error('Error loading report data', { position: 'bottom-right', autoClose: 4000 });
        } finally {
            setLoading(false);
        }
    };

    const queryParams = new URLSearchParams(Object.entries(formData).map(([key, value]) => [key, String(value || '')]));

    return (
        <>
            <Card className='mb-4'>
                <Card.Body>
                    <Card.Title></Card.Title>
                    <Card.Text>
                        <div className='row'>
                            <div className='col-md-2'>
                                <Form.Group className="mb-3" controlId="project">
                                    <Form.Label>Project<span className='required'></span></Form.Label>
                                    <Select
                                        value={project}
                                        onChange={handleProjectChange}
                                        options={projects}
                                        menuPosition="fixed"
                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                        isClearable={true}
                                    />
                                </Form.Group>
                            </div>
                            <div className='col-md-2'>
                                <Form.Group className="mb-3" controlId="itemCategory">
                                    <Form.Label>Select Item Category</Form.Label>
                                    <Select
                                        value={itemCategory}
                                        onChange={handleItemCategoryChange}
                                        options={itemCategories}
                                        placeholder={itemCategory.label}
                                        menuPosition="fixed"
                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                    />
                                </Form.Group>
                            </div>
                            <div className='col-md-2'>
                                <Form.Group className="mb-3" controlId="fromDate">
                                    <Form.Label>From Date<span className='required'></span></Form.Label>
                                    <Form.Control 
                                        type="date" 
                                        placeholder="From Date" 
                                        name='fromDate' 
                                        value={formData.fromDate}
                                        onChange={handleChange} 
                                    />
                                </Form.Group>
                            </div>
                            <div className='col-md-2'>
                                <Form.Group className="mb-3" controlId="toDate">
                                    <Form.Label>To Date<span className='required'></span></Form.Label>
                                    <Form.Control 
                                        type="date" 
                                        placeholder="To Date" 
                                        name='toDate' 
                                        value={formData.toDate}
                                        onChange={handleChange} 
                                    />
                                </Form.Group>
                            </div>
                            <div className='col-md-1'>
                                <div className="form-control-sm ps-0 mt-7">
                                    <button className='btn btn-sm btn-primary w-100 p-3' onClick={handleViewReport} disabled={loading}>
                                        {loading && (
                                            <span className="spinner-border spinner-border-sm"></span>
                                        )}
                                        <span>View Report</span>
                                    </button>
                                </div>
                            </div>
                            <div className='col-md-2'>
                                <div className="form-control-sm ps-0 mt-7">
                                    <a className="btn btn-sm btn-primary w-100 p-3 mb-2" href={`${process.env.REACT_APP_BACKEND}actual_expected_stock_report_download?` + queryParams.toString()}><i className='fas fa-download'></i>Excel Download</a>
                                </div>
                            </div>
                        </div>

                    </Card.Text>
                </Card.Body>
            </Card>

            <div className='row'>
                <div className='col-12'>
                    <Table responsive bordered hover>
                        <thead>
                            <tr>
                                <th className='text-center'>Raw Material</th>
                                <th className='text-center'>Category</th>
                                <th className='text-center'>Opening Stock</th>
                                <th className='text-center'>Opening Date</th>
                                <th className='text-center'>Total Purchase</th>
                                <th className='text-center'>Product</th>
                                <th className='text-center'>Packing</th>
                                <th className='text-center'>Size</th>
                                <th className='text-center'>Per Unit Usage</th>
                                <th className='text-center'>Opening Stock</th>
                                <th className='text-center'>Total Production</th>
                                <th className='text-center'>Unit</th>
                                <th className='text-center'>Usage</th>
                                <th className='text-center'>Total Usage</th>
                                <th className='text-center'>Stock</th>
                            </tr>
                        </thead>
                        
                        <tbody>
                           {expectedStockData.map((itemData: any, itemIndex: number) => (
                                itemData.products.map((product: any, prodIndex: number) => (
                                <tr key={`${itemIndex}-${prodIndex}`}>
                                    {prodIndex === 0 && (
                                    <>
                                        <td rowSpan={itemData.products.length}>
                                            <Link to={`reports?type=detailPurchaseItemSearch&idProjects=${formData?.idProjects}&idItems=${itemData.id_items}&fromDate=${formData?.fromDate}&toDate=${formData?.toDate}`} target='_blank'>
                                               {itemData.item?.item_name ?? ''}
                                            </Link>
                                        </td>
                                        <td rowSpan={itemData.products.length}>{itemData.item?.item_category?.category_name ?? ''}</td>
                                        <td rowSpan={itemData.products.length}>{numberFormat(itemData.opening_stock)}</td>
                                        <td rowSpan={itemData.products.length}>{itemData.opening_date}</td>
                                        <td rowSpan={itemData.products.length}>
                                            <Link to={`reports?type=detailPurchaseItemSearch&idProjects=${formData?.idProjects}&idItems=${itemData.id_items}&fromDate=${formData?.fromDate}&toDate=${formData?.toDate}`} target='_blank'>
                                                {numberFormat(itemData.purchase_stock)}
                                            </Link>
                                        </td>
                                    </>
                                    )}
                                    <td>
                                        <Link to={`reports?type=detailSalesItemSearch&idProjects=${formData?.idProjects}&idProducts=${product.product_id}&startDate=${formData?.fromDate}&endDate=${formData?.toDate}`} target='_blank'>
                                            {product.product?.product_name}
                                        </Link>
                                    </td>
                                    <td>{product.product?.packing ?? ''}</td>
                                    <td>{product.product?.size ?? ''}</td>
                                    <td>{product.per_unit_total_quantity}</td>
                                    <td>{numberFormat(product.opening_stock)}</td>
                                    <td>{numberFormat(product.total_production_quantity ?? 0)}</td>
                                    <td>{product.unit?.unit_name ?? ''}</td>
                                    <td>{numberFormat(product.expected_usage)}</td>
                                    {prodIndex === 0 && (
                                    <>
                                        <td rowSpan={itemData.products.length}>{numberFormat(itemData.total_usage)}</td>
                                        <td rowSpan={itemData.products.length}>{numberFormat(itemData.total_expected_stock)}</td>
                                    </>
                                    )}
                                    
                                </tr>
                                ))
                            ))}
                            
                        </tbody>

                    </Table>
                </div>
            </div>
        </>
    );
};

export default ActualExpectedStockReport;
